import React from "react";
import DrawResultPage from "./DrawResultPage";

const OnePmResult = () => <DrawResultPage time="1pm" />;

export default OnePmResult;
